import { __awaiter } from "tslib";
import { logger } from '@lusha/client-logger';
import AjaxUtils from './ajaxUtils';
export const saveContactToWishlist = (contactsData) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        return yield AjaxUtils.post('/v2/wished-contacts', contactsData);
    }
    catch (error) {
        logger.error('Failed to post wishlist contact data ', error);
        return undefined;
    }
});
export const updateWishedContact = (_a) => __awaiter(void 0, [_a], void 0, function* ({ contactId, data }) {
    try {
        return yield AjaxUtils.patch(`/v2/wished-contacts/${contactId}`, data);
    }
    catch (error) {
        logger.error('Failed to update wishlist contact data ', error);
        return undefined;
    }
});
